import { useState, useEffect, useCallback } from 'react';
import { RestClient } from 'nordic/restclient';

const redirect = (loginUrl) => {
  window.location.href = loginUrl;
};

export const usePolyCardInteraction = ({ userId, item, loginUrl }) => {
  const [itemState, setItemState] = useState(item);
  const [isFetching, setIsFetching] = useState(false);
  const restClient = RestClient({});

  useEffect(() => {
    setItemState(item);
  }, [item]);

  const handleBookmark = useCallback(
    async (e, itemId) => {
      e.preventDefault();

      if (isFetching) {
        return;
      }

      if (!userId) {
        redirect(loginUrl);

        return;
      }

      setIsFetching(true);

      try {
        const updatedBookmarkState = !itemState?.bookmark?.bookmarked;

        setItemState((prevState) => ({
          ...prevState,
          bookmark: {
            bookmarked: updatedBookmarkState,
          },
        }));

        const method = updatedBookmarkState ? 'post' : 'delete';
        await restClient[method]('/bookmarks', {
          data: {
            itemId,
          },
        });
      } catch (error) {
        if (error.response?.status === 403) {
          redirect(loginUrl);

          return;
        }

        setItemState((prevState) => ({
          ...prevState,
          bookmark: {
            bookmarked: itemState.bookmark.bookmarked,
          },
        }));
      } finally {
        setIsFetching(false);
      }
    },
    [isFetching, userId, loginUrl, itemState],
  );

  return {
    itemState,
    handleBookmark,
  };
};
